import React, { useRef } from 'react';
import DataGrid,{ Column, Export, Button as ButtonGrid } from 'devextreme-react/data-grid';
import Nuevo from './Nuevo';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import BlockHeader from '../shared/BlockHeader';
import Title from '../shared/Title';
import CustomButton from '../buttons/CustomButton';
import { useDispatch } from 'react-redux';
import { updateContactologia } from '../../store/contactologia/contactologiaReducer';
const Contactologia = props => {

    const { id } = props;

    const dispatch = useDispatch();

    let dataGrid =useRef();

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.exportToExcel(false)
            }
        });
    }  

    const openDialog = _id => {
        dispatch(updateContactologia({ open: true,clientId : id, id : _id}))
    }

    const onRowDblClick = (e) => {
        openDialog(e.data.id);
    }

    const reload = () => dataGrid.current.instance.refresh()

    const title = "Lentes de contacto";

    return (
        <div>
            <Title title={title} />
            <BlockHeader title={title}>
                <CustomButton
                    type="default"
                    text="Agregar nuevo"
                    icon='plus'                   
                    onClick={()=>  openDialog(0)}
                />
            </BlockHeader>
            <Nuevo reload={reload}/>
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri: uri.contactLenses(id) })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                rowAlternationEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                onRowDblClick={onRowDblClick}
            >                
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                <Column type="buttons">
                    <ButtonGrid name="modificar" text="Ver" onClick={e => openDialog(e.row.data.id)}/>
                </Column>
                <Column dataField="date" caption="Fecha" width={120} dataType="date" format="dd/MM/yyyy" />
                <Column dataField="resumenOd" allowFiltering={false} />
                <Column dataField="resumenOi" allowFiltering={false} />               
                <Column dataField="createBy" caption="Creado por" allowFiltering={false} />               
            </DataGrid>
        </div>
    );
}

export default Contactologia;
